<!-- Table Prenotazioni Attive -->
<app-kontable
  #importGiftTable
  title="{{ 'reservations.importExcel' | translate }}"
  [columns]="[
    {field: 'id', title: 'ID'},
    {field: 'description', title: 'common.description'},
    {field: 'dt_import', title: 'reservations.dtImport', type: 'date', filterType: dateFilter},
    {field: 'file_name', title: 'reservations.nameFile'},
    {field: 'flg_kf', title: 'common.status', filterType: selectFilter, bodyTemplate: errorLog, filterOptions: {values: optionError} }
  ]"
  [service]="importService"
  (onAdd)="addGift()"
  (onRemove)="deleteImport($event.id)"
  [paginationType]="paginationType"
  [showRecoverButton]="false"
  [showInfoButton]="false"
  [showAddButton]="true"
  [showDeleteButton]="true"
  [showDetailsButton]="false"
  [showEditButton]="false"
  [showReport]="true"
  [showGlobalFilter]="false"
  [additionalRowCommands]="customRow"
>

<!-- Bottone Record Importati -->
<ng-template #customRow data-testid="customRow" let-row>
  <p-button *ngIf="row.flg_kf != '0' " pTooltip="{{ 'common.view' | translate }}" icon="fa fas fa-eye"  styleClass="ui-button-info" (onClick)="openPopUp(row)"></p-button>
  <p-button *ngIf="row.flg_kf != '0' " pTooltip="{{'common.info' | translate }}" icon="fa fa-exclamation-circle" styleClass="ui-button-info" (onClick)="openImportGiftRowsDetail(row)"></p-button>
</ng-template>

<!-- Template Error-->
<ng-template #errorLog data-testid="errorLog" let-row>
  <span *ngIf="row.flg_kf == '0' ">{{ 'reservations.importSuccessful' | translate }}</span>
  <span *ngIf="row.flg_kf == '3' ">{{ 'reservations.importSuccessfulMissImages' | translate }}</span>
  <span *ngIf="row.flg_kf == '2' ">{{ 'reservations.importFailed' | translate }}</span>
  <span *ngIf="row.flg_kf == '1' ">{{ 'reservations.loadingImport' | translate }}</span>
</ng-template>

</app-kontable>

<!-- Pop-up di Dettaglio di un record per gli error_log-->
<p-dialog
*ngIf="popUp"
[(visible)]="popUp"
[modal]="true"
header="{{ 'reservations.headerImport' | translate}}"
[minWidth]="500"
[draggable]="false"
[resizable]="false"
(onHide)="closePopUp()">

<span><label style="font-weight: bold;">{{ 'reservations.messageImport' | translate }}: </label>
  <br>
  <br>
  {{record.error_log}}
</span>

</p-dialog>




// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-import-gift/loyalty-import-gift.component.html